/** @format */
import React from "react";
import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";

const Sidebar = ({ selectedZone, onZoneChange, onSelect = () => {} }) => {
  
  const zones = [
    { id: "SZone", name: "Solar Zone", color: "#3b82f6" },
    { id: "WZone", name: "Wind Zone", color: "#10b981" },
  ];
  // const navigate = useNavigate();
   const location = useLocation();
  // const tabs = [
  //   { id: "analysis", label: "📊 Analysis" },
  //   { id: "weather", label: "🌤️ Weather" },
  //   { id: "map", label: "🗺️ Map" },
  //   { id: "settings", label: "⚙️ Settings" },
  // ];
  const handleClick = (event) => {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  };

  return (
    <div className="sidebar">
      {/* Sidebar Header */}
      <div className="sidebar-header">
        <h3>Dashboard</h3>
        <span className="breadcrumbs">
          <h2>Zones</h2>
          <div
            role="presentation"
            className="custom-breadcrumbs"
            onClick={handleClick}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="#fffff" href="/">
                Home
              </Link>
              {selectedZone && (
                <Link underline="hover" color="inherit">
                  {zones.find((z) => z.id === selectedZone)?.name}
                </Link>
              )}
            </Breadcrumbs>
          </div>
        </span>
      </div>

      {/* Zone Selector */}
      <div className="zone-selector">
        {zones.map((zone) => (
          <button
            key={zone.id}
            className={`zone-button ${
              selectedZone === zone.id ? "active" : ""
            }`}
            onClick={() => onZoneChange(zone.id)}
            style={{
              backgroundColor:
                selectedZone === zone.id ? zone.color : "transparent",
              borderColor: zone.color,
              color: selectedZone === zone.id ? "white" : zone.color,
            }}>
            {zone.name}
          </button>
        ))}
      </div>

      {/* Sidebar Menu */}
      <div className="sidebar-menu">
        <ul className="nav-links">
          <li className={location.pathname === "/" ? "active" : ""}>
            <Link to="/">Dashboard</Link>
          </li>
          <li className={location.pathname === "/analysis" ? "active" : ""}>
            <Link to="/analysis">Analysis</Link>
          </li>
          <li className={location.pathname === "/weather" ? "active" : ""}>
            <Link to="/weather">Weather</Link>
          </li>
          <li className={location.pathname === "/map" ? "active" : ""}>
            <Link to="/map">Map</Link>
          </li>
          <li className={location.pathname === "/settings" ? "active" : ""}>
            <Link to="/settings">Settings</Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
